var xP = require('../../xP');

module.exports = {
  name: 'repeat_remove_button', base: 'button', prototype: {
    element_selector: '.repeat_remove_button',

    init: function (params) {
      xP.controls.repeat_remove_button.base.init.apply(this, arguments);

      var parent = this.parent(), repeat = parent.repeat;

      if (!(repeat instanceof xP.repeats.item)) {
        return;
      }

      this.$element.click(function () {
        repeat.remove(parent);

        return false;
      });

      this.enabled = {
        on: function () {
          return repeat.val() > repeat.min
        }, from: repeat
      };
    }
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./lib/controls/repeats/repeat_remove_button.js
 ** module id = 33
 ** module chunks = 0
 **/